import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=d936164c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=d936164c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d936164c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d936164c')) {
      api.createRecord('d936164c', component.options)
    } else {
      api.reload('d936164c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=d936164c&scoped=true&", function () {
      api.rerender('d936164c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HG6M6uozGXUM/JS/comp/PopupDialog.vue"
export default component.exports